import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { ContentProvider } from "./context/ContentContext";
import { AuthProvider } from "./context/AuthContext";
import SmoothScroll from "./components/SmoothScroll";
import CookieBanner from "./components/site/CookieBanner";
import Landing from "./pages/Landing";
import PageView from "./pages/PageView";
import AdminLogin from "./pages/admin/Login";
import AdminDashboard from "./pages/admin/Dashboard";

function App() {
  return (
    <div className="App">
      <div className="grain-overlay" />
      <ContentProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route
                path="/"
                element={
                  <SmoothScroll>
                    <Landing />
                  </SmoothScroll>
                }
              />
              <Route path="/portal" element={<AdminLogin />} />
              <Route path="/portal/dashboard" element={<AdminDashboard />} />
              <Route
                path="/:slug"
                element={
                  <SmoothScroll>
                    <PageView />
                  </SmoothScroll>
                }
              />
            </Routes>
            <CookieBanner />
          </BrowserRouter>
        </AuthProvider>
      </ContentProvider>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#1A1A1A",
            border: "1px solid #333333",
            color: "#F2F2E8",
            borderRadius: "0",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
